/**
 * @file error-display.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _modalDialog = require('./modal-dialog');

var _modalDialog2 = _interopRequireDefault(_modalDialog);

var _utilsDom = require('./utils/dom');

var Dom = _interopRequireWildcard(_utilsDom);

var _utilsMergeOptions = require('./utils/merge-options');

var _utilsMergeOptions2 = _interopRequireDefault(_utilsMergeOptions);

/**
 * Display that an error has occurred making the video unplayable.
 *
 * @extends ModalDialog
 * @class ErrorDisplay
 */

var ErrorDisplay = (function (_ModalDialog) {
  _inherits(ErrorDisplay, _ModalDialog);

  /**
   * Constructor for error display modal.
   *
   * @param  {Player} player
   * @param  {Object} [options]
   */

  function ErrorDisplay(player, options) {
    _classCallCheck(this, ErrorDisplay);

    _ModalDialog.call(this, player, options);
    this.on(player, 'error', this.open);
  }

  /**
   * Include the old class for backward-compatibility.
   *
   * This can be removed in 6.0.
   *
   * @method buildCSSClass
   * @deprecated
   * @return {String}
   */

  ErrorDisplay.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-error-display ' + _ModalDialog.prototype.buildCSSClass.call(this);
  };

  /**
   * Opens modal dialog only for error codes not configured for ignore.
   */

  ErrorDisplay.prototype.open = function open() {
    var error = this.player().error(),
        ignore = this.options_.ignoreErr;
    if (error && (ignore === true || typeof ignore === 'number' && ignore === error.code || ignore instanceof Array && ignore.indexOf(error.code) >= 0)) {
      return this;
    }
    return _ModalDialog.prototype.open.call(this);
  };

  /**
   * Generates the modal content based on the player error.
   *
   * @return {String|Null}
   */

  ErrorDisplay.prototype.content = function content() {
    var error = this.player().error();
    return error ? this.localize(error.message) : '';
  };

  return ErrorDisplay;
})(_modalDialog2['default']);

ErrorDisplay.prototype.options_ = _utilsMergeOptions2['default'](_modalDialog2['default'].prototype.options_, {
  fillAlways: true,
  temporary: false,
  uncloseable: true,
  ignoreErr: false
});

_component2['default'].registerComponent('ErrorDisplay', ErrorDisplay);
exports['default'] = ErrorDisplay;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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